<template>
    <div class="panel panel-default" data-testid="order-detail-payment">
        <div class="panel-heading">
            <h4>{{ label }}</h4>
        </div>
        <div class="panel-body no-padding">
            <dl class="order-detail-v1-field-grid">
                <div
                    v-for="item in items"
                    :key="item.label"
                    class="order-detail-v1-field-grid__cell"
                >
                    <dt>{{ item.label }}</dt>
                    <dd>{{ item.value }}</dd>
                </div>
            </dl>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderPaymentCard',
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    computed: {
        label() {
            return this.order.ui?.labels?.payment || 'Pagamento';
        },
        payment() {
            return this.order.payment || null;
        },
        items() {
            const p = this.payment;
            if (!p) {
                return [];
            }

            return [
                { label: 'Gateway', value: p.gateway || '—' },
                { label: 'Importo', value: p.amountFormatted || '—' },
                { label: 'Stato', value: p.status || '—' },
                { label: 'Transazione', value: p.transactionId != null ? String(p.transactionId) : '—' },
                { label: 'Ricevuto il', value: p.receivedAt || '—' },
                { label: 'IGU carta', value: p.cardIgu || '—' },
                { label: 'Fast payment', value: p.fastPayment || '—' },
            ];
        },
    },
};
</script>
